import React, { Component } from 'react';
import './Svg.scss';
import './Icon.scss';

export default class JoinIcon extends Component {
    render () {
        const { className, colorIndex, size } = this.props;
        let colorClass = 'color--' + colorIndex;
        let sizeClass = 'size--' + size;
        let finalClassName = "Icon " + className + " " + sizeClass + " " + colorClass;

        return (
            <svg className={finalClassName} width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.1916 4.66054L5.99976 7.94197L10.1834 11.3608C10.5099 11.6276 10.9998 11.3954 10.9998 10.9737L11 8.53243L11 10.0279L14 10.0279C15.1046 10.0279 16 9.13248 16 8.02791C16 6.92334 15.1046 6.02791 14 6.02791L11 6.02791L11 8.52267L10.9998 5.05423C10.9998 4.63744 10.5198 4.40363 10.1916 4.66054Z"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M5.2 4C4.64772 4 4.2 4.44772 4.2 5L4.2 11C4.2 11.5523 4.64772 12 5.2 12H7C8.10457 12 9 12.8954 9 14C9 15.1046 8.10457 16 7 16H4.2H3.5H3C1.89543 16 1 15.1046 1 14V2C1 0.895431 1.89543 0 3 0H3.5H4.2H7.4C8.28366 0 9 0.895431 9 2C9 3.10457 8.28366 4 7.4 4H5.2Z"/>
            </svg>);
    }
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Icon/Join.js